import { type CSSProperties } from "react"

type RoboticGripperIconProps = {
  size?: number
  strokeWidth?: number
  style?: CSSProperties
}

// Hand-authored stroke version of Siemens Industrial Experience Icons'
// `ix:robotic-gripper` (MIT-licensed): a top mounting nub + bracket, short
// vertical body, two arms splaying outward, then claws angling back inward to
// near-center tips. Redrawn on a 24x24 viewBox so it matches the stroke
// weight/style of the adjacent lucide icons in the labor-mix segments.
export const RoboticGripperIcon = ({
  size = 24,
  strokeWidth = 1.75,
  style,
}: RoboticGripperIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={style}
    aria-hidden
  >
    <rect x="11" y="0" width="2" height="2" />
    <rect x="9" y="2" width="6" height="3" />
    <line x1="12" y1="5" x2="12" y2="9" />
    <path d="M12 9 L 4 12 L 10 22 L 11 22 L 11 13" />
    <path d="M12 9 L 20 12 L 14 22 L 13 22 L 13 13" />
  </svg>
)
